import { render } from "./AppRegister.vue?vue&type=template&id=38430a39"
import script from "./AppRegister.vue?vue&type=script&lang=js"
export * from "./AppRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__